// @flow
import React from 'react';

import ratioUtils from 'Components/utils/ratios/ratios.utils';

import Image from 'Components/frameworks/image/Image.jsx';
import { Text } from 'Components/frameworks/text/Text.jsx';
import { Title } from 'Components/frameworks/title/Title.jsx';

type Props = {
  className?: string,
  description: ?string,
  imageSrc?: ?string,
  title: ?string,
};

export function ProductFeatureDetailBrandInformation({
  className,
  description,
  imageSrc,
  title,
}: Props) {
  if (!description) {
    return null;
  }

  const hasImage = !!imageSrc;
  const desc = <Text text={description} />;

  return (
    <section className={className}>
      <Title className="mb-8" hLevel={3} theme="title-brand-6">
        {title}
      </Title>
      {hasImage ? (
        <div className="flex flex-col sm:flex-row -mx-5">
          <div className="flex-none px-5 sm:w-1/2">{desc}</div>
          <div className="flex-none px-5 mt-5 sm:mt-0 sm:w-1/2">
            <Image imageUrl={imageSrc} ratioKey={ratioUtils.XL} />
          </div>
        </div>
      ) : (
        desc
      )}
    </section>
  );
}
